import React, { useEffect } from "react";
import CustomerGroup from "../../Assets/CustomerGroup.png";
import Star from "../Icons/Star";
import AOS from "aos";
import "aos/dist/aos.css";

export default function HeroReview() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <div
      className="flex items-center gap-4 mx-auto sm:mx-0"
      data-aos="fade-up"
      data-aos-delay="450"
    >
      <img src={CustomerGroup} alt="Customers" className="w-32 sm:w-auto" />
      <div>
        <p className="text-sm font-bold sm:text-base">Pelanggan Setia MiTime</p>
        <div className="flex gap-2">
          <Star color="#ffe234" />
          <p className="text-sm text-text-gray sm:text-base">
            4.8 (3.2k Reviews)
          </p>
        </div>
      </div>
    </div>
  );
}
